import { render, staticRenderFns } from "./addReductionComponent.vue?vue&type=template&id=2c56c9ad&scoped=true"
import script from "./addReductionComponent.vue?vue&type=script&lang=js"
export * from "./addReductionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c56c9ad",
  null
  
)

export default component.exports